<!-- 快速打单 -->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/admin/stock'}">{{msg('货运管理')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('快速打印')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-alert
            :title="warningMsg"
            type="error">
        </el-alert>
        <el-row style="padding: 20px 20px; ">
            <el-col :xs="24" :sm="10">
                <el-input v-model="code" ref="codeRef" :placeholder="msg('请扫描订单编号、面单码、袋号')" 
                    size="medium" 
                    @keyup.native="autoSelectCode">
                    <el-select v-model="codeType" slot="append" clearable style=" width: 130px;" placeholder="单号类型选择">
                        <el-option :label="msg('订单编号')" :value="0" ></el-option>
                        <el-option :label="msg('面单码')" :value="1" ></el-option>
                        <el-option :label="msg('查询码')" :value="2" ></el-option>
                        <el-option :label="msg('袋号')" :value="3" ></el-option>
                    </el-select>
                </el-input>
            </el-col>
            <el-col :xs="24" :sm="8">
                <template>
                    <!-- <el-button type="primary" size="medium"  @click="doPrint"><i class="el-icon-check"></i><span>{{msg('打印当前')}}</span></el-button> -->
                    <el-checkbox style="margin-left:10px;margin-top:7px" v-model="pastType">代贴单登记</el-checkbox>
                    <el-checkbox style="margin-left:5px;margin-top:7px" v-model="syncPrint" @change="changeSyncPrint">{{ msg('开启异步打印') }}</el-checkbox>
                    <el-checkbox style="margin-left:5px;margin-top:7px" v-model="printPdf" @change="changePdfPrint">{{ msg('开启PDF打印') }}</el-checkbox>
                    <el-checkbox style="margin-left:5px;margin-top:7px" v-model="isCancel">{{ msg('面单提示') }}</el-checkbox>
                </template>
            </el-col>
        </el-row>
        <el-row style="padding: 20px 20px;" v-if="tag">
            <el-col :xs="24" :sm="12">
                <template>
                    <el-tag type="success">{{tag}}</el-tag>
                </template>
            </el-col>
        </el-row>

        <div class="page-tpl">
            <vue-easy-print tableShow ref="easyPrint" :afterPrint="printFinished">
                <template>
                    <print-tpl :datas="printDtos" ></print-tpl>
                </template>
            </vue-easy-print>
        </div>

        <div style="display:inline-block; width:1px; height:1px; overflow:hidden;">
            <audio controls="controls" preload ref="audioRef"></audio>
        </div>

    </div>
</template>

<script>
import Cancel from "../../assets/media/Cancel.mp3"; //订单已取消
import OkMp3 from "../../assets/media/ok.mp3"; //成功
import Warning from "../../assets/media/warning.wav";//滴滴音
import unexistPageMp3 from "../../assets/media/page_unexist.mp3";  //面单不存在
import yushua from "../../assets/media/yushua.mp3";  //预刷
import kuacanghbb from "../../assets/media/kuacanghbb.mp3";
import hdbg from "../../assets/media/hdbg.mp3";
import vueEasyPrint from "../../components/vue-easy-print";
import PrintTpl from "./StockPrintFastTpl";
export default {
  name: 'StockPrintFast',
  components:{
        PrintTpl : PrintTpl,
        vueEasyPrint: vueEasyPrint,
    },
  data(){
    return{
        code:null,
        printDtos:[],
        datas:[],
        codes:[],
        pastType:true,
        audioUrl:null,
        codeType:0,
        tag:null,
        syncPrint: false,
        waitingCodes: [],
        syncFirstPrint: false,
        syncTimer: null,
        times: 0,
        printing: false,
        warningMsg: "提示",
        printPdf:false,
        isCancel:true,
    }
    
  }, 
  computed:{
  },
  mounted(){
    this.code = null;
    this.printDtos = [];
    this.waitingCodes = [];
    this.$refs['codeRef'].focus();
  },
  watch:{
      $route(){
        //跳转到该页面后需要进行的操作
        this.code = null;
        this.printDtos = [];
        this.$refs['codeRef'].focus();
        this.waitingCodes = [];
      }
    },
  methods:{
    printFinished(){
        // console.log('Print task completed');
        if(this.waitingCodes.length>0){
            let code = this.waitingCodes.pop();
            setTimeout(()=>{
                this.selectStock(code);
            }, 60);
        }else{
            this.printing = false;
            this.times = 0;
        }
    },
    changeSyncPrint(value){
        this.syncFirstPrint = value;
        if(value){
            this.waitingCodes = [];
            this.syncTimer = setInterval(this.doSyncPrint, 1000);
            this.warningMsg = "异步打印开启以后，可以一直扫描，停止3s以上没有扫描就会开始打印之前按扫描顺序打印之前扫描的单号";
        }else {
            if(this.syncTimer){
                clearInterval(this.syncTimer);
            }            
            this.warningMsg = "提示";
        }
    },
    doSyncPrint(){
        if(this.printing || this.waitingCodes.length == 0){
            return;
        }

        if(this.times >= 4){
            this.printFinished();
            this.printing = true;
            return;
        }

        this.times += 1;

    },
    //勾选了PDF打印需要做的操作
    changePdfPrint(){
        let startService = async ()=> {
            try {
                // window.location.href ="sybprintservice://start"

                const response = await fetch('http://localhost:9987/health');
                const text = await response.text();
                const [status, message] = text.split('##');
                
                if (status === 'true') {
                    // this.$message('服务已启动: ' + message)
                } else {
                    this.$message('服务异常: ' + message)
                    this.printPdf = false;
                    return;
                }
            } catch (error) {
                this.printPdf = false;
                window.location.href ="sybprintservice://start"
                return;
            }
        }
        startService();
    },
    autoSelectCode(e){
        if(e.keyCode == 13){
            // this.codes.splice(0,0,this.code);
            if(this.syncPrint){
                this.waitingCodes.push(this.code);
                this.code = null;
                // if(this.syncFirstPrint){
                //     this.printFinished();
                // }
                this.audioUrl = Warning;
                this.playAudio();
            }else{
                this.selectStock(this.code);
            }
        }

    },
    selectStock(code){
        if(!this.hasPermission('stock:printFastMiandan')){
            this.$message(this.msg('抱歉，会员权限不够，请升级会员!'));
            return;
        }
        // let temp = this.codes.pop();
        let type = this.codeType?this.codeType:0;
        this.$axios.get(this.$kit.api.stock.getFastPrintData+"?code="+code+"&pastType="+this.pastType+"&type="+type+"&printPdf="+this.printPdf+'&cancel='+this.isCancel,)
            .then((result) =>{
                if(result.status){
                    this.printDtos.splice(0,this.printDtos.length);
                    let data = result.data;

                    if(this.isCancel && result.msg == '面单码'){
                        if(data && data > 0){
                            //播报取消件
                            this.audioUrl = Cancel;
                        }else{
                            //播报成功
                            this.audioUrl = OkMp3;
                        }
                        this.playAudio();
                        return;
                    }

                    if(data && data.length > 0){
                        //检查该单号的打包类型是否是跨仓合并包；如果是，播放跨仓合并包的语音，然后再正常执行其它逻辑；如果其打包类型不是跨仓合并包，直接执行其它逻辑
                        let stock = data[0];
                        if(stock.expPkgType && stock.expPkgType == 31){
                            this.audioUrl = kuacanghbb;
                            this.playAudio();
                        }

                        if(stock.isReplace && stock.isReplace == 1){
                            this.audioUrl = hdbg;
                            this.playAudio();
                        }

                        this.printDtos = data;
                        let dto = data[0];
                        if(dto.code.indexOf("面单不存在") > -1){
                            //声音提示不存在
                            this.audioUrl = unexistPageMp3;
                            this.tag = '';
                            this.playAudio();
                        }else if(dto.code.indexOf("订单已取消") > -1){
                            //声音提示已取消
                            // console.log("播放订单已取消");
                            this.audioUrl = Cancel;
                            this.tag = '';
                            this.playAudio();
                        }else{
                            if(dto.remark7){
                                //语音播报预刷
                                this.audioUrl = yushua;
                                this.playAudio();
                                this.tag = "预刷件";
                            }else{
                                this.tag = '';
                            }
                            this.doPrint();
                        }

                    }else{
                        this.printDtos=[];
                        this.audioUrl = Warning;
                        this.playAudio();
                        this.$message(this.msg("单号不存在"));
                        this.tag = '';
                        return;
                    }
                }else{
                    this.tag = '';
                    this.$message({
                        message: result.msg,
                        type: 'error'
                    });
                }
            });

        this.code = null;
    },
    async doLocalPrint(pdfAsBase64){
        try {
            const response = await fetch('http://localhost:9987/print', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: 
                    JSON.stringify({
                        code: new Date().getTime().toString(),
                        expCompany: '黑貓',
                        data: pdfAsBase64,
                        useDialogSetting: 1,
                        type: 1  //1-PDF,2-图片
                    })
            });

            const text = await response.text();
            const [status, message] = text.split('##');
            
            if (status === 'true') {
                // alert('成功: ' + message);
            } else {
                this.$message('错误: ' + message);
            }
        } catch (error) {
            this.$message('请求失败: ' + error.message);
        }
    },
    doPrint(){
        // this.printDtos = this.datas.pop();
        if(this.printPdf){
            //打印PDF
            let printDatas = this.printDtos;
            let pdfAsBase64 = printDatas[0].pageAsBase64;
            if(pdfAsBase64){
                this.doLocalPrint(pdfAsBase64);
            }else{
                this.$message("无PDF数据，请检查是否已建单");
            }
        }else{
            setTimeout(()=>{
                this.$refs.easyPrint.print();
            }, 200);
        }
    },
    playAudio(){
        let audio = this.$refs.audioRef;
        audio.src = this.audioUrl;
        audio.play();
    },
  }
}
</script>

<style scoped lang="scss">

</style>
